const config = {
  mainTitle: 'Events',
  subHeading: 'A page to see event bookings.(Note: Price is *100 here)',
  titleIcon: 'IosBookmarksOutline'
}

export default config;
